import { Variant } from "../../types/types";

export const isVariantReducedToClear = (variant: Variant) => {
  return variant.price ? variant.price.offerType === "ReducedToClear" : false;
};
